import { ActionTypesFactory } from '../factories/actionTypes.factory';

export default ActionTypesFactory('TIMEFRAMES');
